<template>
  <div>
    <Head title="Create User" />

    <Head title="Create User" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/users">Users</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create User</li>
      </ol>
    </nav>
    <h1>Create User</h1>

      <form @submit.prevent="store">
        <div class="content-box">
          <text-input v-model="form.first_name" :error="form.errors.first_name" label="First name" />

          <text-input v-model="form.last_name" :error="form.errors.last_name" label="Last name" />

          <text-input v-model="form.email" :error="form.errors.email" label="Email" />

          <text-input v-model="form.password" :error="form.errors.password" type="password" autocomplete="new-password" label="Password" />

          <select-input v-if="auth.user.role_admin" v-model="form.role" :error="form.errors.role" label="Role">
            <option value="1">Admin</option>
            <option value="2">Agency Owner</option>
            <option value="0">Agent</option>
          </select-input>

          <select-input v-if="auth.user.role_admin || auth.user.role_main_agent" v-model="form.agencies_id" :error="form.errors.agencies_id" label="Agency">
            <option>Select Agency</option>
            <option v-for="agency in agencies" :key="agency.id" :value="agency.id">{{ agency.name }}</option>
          </select-input>

          <div class="actions-toolbar">
            <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create User</loading-button>
          </div>
        </div>
      </form>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    agencies: Object,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        role: 0,
        agencies_id: this.$page.props.auth.user.agency.id
      }),
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
